/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PortfolioStatus } from './PortfolioStatus';
import {
    PortfolioStatusFromJSON,
    PortfolioStatusFromJSONTyped,
    PortfolioStatusToJSON,
    PortfolioStatusToJSONTyped,
} from './PortfolioStatus';
import type { PortfolioAdditionalClassification } from './PortfolioAdditionalClassification';
import {
    PortfolioAdditionalClassificationFromJSON,
    PortfolioAdditionalClassificationFromJSONTyped,
    PortfolioAdditionalClassificationToJSON,
    PortfolioAdditionalClassificationToJSONTyped,
} from './PortfolioAdditionalClassification';
import type { PortfolioType } from './PortfolioType';
import {
    PortfolioTypeFromJSON,
    PortfolioTypeFromJSONTyped,
    PortfolioTypeToJSON,
    PortfolioTypeToJSONTyped,
} from './PortfolioType';
import type { PortfolioLinkType } from './PortfolioLinkType';
import {
    PortfolioLinkTypeFromJSON,
    PortfolioLinkTypeFromJSONTyped,
    PortfolioLinkTypeToJSON,
    PortfolioLinkTypeToJSONTyped,
} from './PortfolioLinkType';
import type { PortfolioExternalAccountType } from './PortfolioExternalAccountType';
import {
    PortfolioExternalAccountTypeFromJSON,
    PortfolioExternalAccountTypeFromJSONTyped,
    PortfolioExternalAccountTypeToJSON,
    PortfolioExternalAccountTypeToJSONTyped,
} from './PortfolioExternalAccountType';
import type { PortfolioServicingRole } from './PortfolioServicingRole';
import {
    PortfolioServicingRoleFromJSON,
    PortfolioServicingRoleFromJSONTyped,
    PortfolioServicingRoleToJSON,
    PortfolioServicingRoleToJSONTyped,
} from './PortfolioServicingRole';
import type { PortfolioCashAccountDetails } from './PortfolioCashAccountDetails';
import {
    PortfolioCashAccountDetailsFromJSON,
    PortfolioCashAccountDetailsFromJSONTyped,
    PortfolioCashAccountDetailsToJSON,
    PortfolioCashAccountDetailsToJSONTyped,
} from './PortfolioCashAccountDetails';

/**
 * 
 * @export
 * @interface PortfolioDetails
 */
export interface PortfolioDetails {
    /**
     * 
     * @type {string}
     * @memberof PortfolioDetails
     */
    portfolioId?: string;
    /**
     * PCO portfolio number in dotted form {type}.{seq} (e.g. 02.02)
     * @type {string}
     * @memberof PortfolioDetails
     */
    portfolioNumber?: string;
    /**
     * Unformatted sequence number of the portfolio within the business relationship (e.g. 1 for portfolio number 02.01).
     * @type {number}
     * @memberof PortfolioDetails
     */
    sequenceNumber?: number;
    /**
     * 
     * @type {string}
     * @memberof PortfolioDetails
     */
    rubrik?: string;
    /**
     * 
     * @type {string}
     * @memberof PortfolioDetails
     */
    details?: string;
    /**
     * 
     * @type {PortfolioType}
     * @memberof PortfolioDetails
     */
    portfolioType?: PortfolioType;
    /**
     * 
     * @type {PortfolioStatus}
     * @memberof PortfolioDetails
     */
    portfolioStatus?: PortfolioStatus;
    /**
     * 
     * @type {string}
     * @memberof PortfolioDetails
     */
    referenceCurrency?: string;
    /**
     * 
     * @type {string}
     * @memberof PortfolioDetails
     */
    chargingCurrency?: string;
    /**
     * 
     * @type {string}
     * @memberof PortfolioDetails
     */
    allocatedBo?: string;
    /**
     * 
     * @type {string}
     * @memberof PortfolioDetails
     */
    allocatedBoName?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PortfolioDetails
     */
    specialBoEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PortfolioDetails
     */
    businessRelationshipId?: string;
    /**
     * 
     * @type {string}
     * @memberof PortfolioDetails
     */
    serviceAgreementId?: string;
    /**
     * 
     * @type {Date}
     * @memberof PortfolioDetails
     */
    closedAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof PortfolioDetails
     */
    activatedAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof PortfolioDetails
     */
    createdAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof PortfolioDetails
     */
    createdBy?: string;
    /**
     * 
     * @type {Date}
     * @memberof PortfolioDetails
     */
    modifiedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof PortfolioDetails
     */
    modifiedBy?: string;
    /**
     * define if the overview Edit action is available for this portfolio
     * @type {boolean}
     * @memberof PortfolioDetails
     */
    canBeEdited?: boolean;
    /**
     * resolved server-side: true if the current user may change the portfolio details. Ignored if sent back on write.
     * 
     * @type {boolean}
     * @memberof PortfolioDetails
     */
    canEditDetails?: boolean;
    /**
     * 
     * @type {Array<PortfolioCashAccountDetails>}
     * @memberof PortfolioDetails
     */
    cashAccounts?: Array<PortfolioCashAccountDetails>;
    /**
     * 
     * @type {PortfolioServicingRole}
     * @memberof PortfolioDetails
     */
    servicingRole?: PortfolioServicingRole;
    /**
     * External account number of the portfolio, if it has one.
     * @type {string}
     * @memberof PortfolioDetails
     */
    externalAccountNumber?: string;
    /**
     * 
     * @type {PortfolioExternalAccountType}
     * @memberof PortfolioDetails
     */
    externalAccountType?: PortfolioExternalAccountType;
    /**
     * 
     * @type {string}
     * @memberof PortfolioDetails
     */
    remarks?: string;
    /**
     * 
     * @type {PortfolioAdditionalClassification}
     * @memberof PortfolioDetails
     */
    additionalClassification?: PortfolioAdditionalClassification;
    /**
     * 
     * @type {string}
     * @memberof PortfolioDetails
     */
    linkedPortfolioId?: string;
    /**
     * 
     * @type {PortfolioLinkType}
     * @memberof PortfolioDetails
     */
    linkType?: PortfolioLinkType;
    /**
     * Status of the link to the linked portfolio. Follows the status of this portfolio.
     * @type {string}
     * @memberof PortfolioDetails
     */
    linkStatus?: string;
}



/**
 * Check if a given object implements the PortfolioDetails interface.
 */
export function instanceOfPortfolioDetails(value: object): value is PortfolioDetails {
    return true;
}

export function PortfolioDetailsFromJSON(json: any): PortfolioDetails {
    return PortfolioDetailsFromJSONTyped(json, false);
}

export function PortfolioDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): PortfolioDetails {
    if (json == null) {
        return json;
    }
    return {
        
        'portfolioId': json['portfolioId'] == null ? undefined : json['portfolioId'],
        'portfolioNumber': json['portfolioNumber'] == null ? undefined : json['portfolioNumber'],
        'sequenceNumber': json['sequenceNumber'] == null ? undefined : json['sequenceNumber'],
        'rubrik': json['rubrik'] == null ? undefined : json['rubrik'],
        'details': json['details'] == null ? undefined : json['details'],
        'portfolioType': json['portfolioType'] == null ? undefined : PortfolioTypeFromJSON(json['portfolioType']),
        'portfolioStatus': json['portfolioStatus'] == null ? undefined : PortfolioStatusFromJSON(json['portfolioStatus']),
        'referenceCurrency': json['referenceCurrency'] == null ? undefined : json['referenceCurrency'],
        'chargingCurrency': json['chargingCurrency'] == null ? undefined : json['chargingCurrency'],
        'allocatedBo': json['allocatedBo'] == null ? undefined : json['allocatedBo'],
        'allocatedBoName': json['allocatedBoName'] == null ? undefined : json['allocatedBoName'],
        'specialBoEnabled': json['specialBoEnabled'] == null ? undefined : json['specialBoEnabled'],
        'businessRelationshipId': json['businessRelationshipId'] == null ? undefined : json['businessRelationshipId'],
        'serviceAgreementId': json['serviceAgreementId'] == null ? undefined : json['serviceAgreementId'],
        'closedAt': json['closedAt'] == null ? undefined : (new Date(json['closedAt'])),
        'activatedAt': json['activatedAt'] == null ? undefined : (new Date(json['activatedAt'])),
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'createdBy': json['createdBy'] == null ? undefined : json['createdBy'],
        'modifiedAt': json['modifiedAt'] == null ? undefined : (new Date(json['modifiedAt'])),
        'modifiedBy': json['modifiedBy'] == null ? undefined : json['modifiedBy'],
        'canBeEdited': json['canBeEdited'] == null ? undefined : json['canBeEdited'],
        'canEditDetails': json['canEditDetails'] == null ? undefined : json['canEditDetails'],
        'cashAccounts': json['cashAccounts'] == null ? undefined : ((json['cashAccounts'] as Array<any>).map(PortfolioCashAccountDetailsFromJSON)),
        'servicingRole': json['servicingRole'] == null ? undefined : PortfolioServicingRoleFromJSON(json['servicingRole']),
        'externalAccountNumber': json['externalAccountNumber'] == null ? undefined : json['externalAccountNumber'],
        'externalAccountType': json['externalAccountType'] == null ? undefined : PortfolioExternalAccountTypeFromJSON(json['externalAccountType']),
        'remarks': json['remarks'] == null ? undefined : json['remarks'],
        'additionalClassification': json['additionalClassification'] == null ? undefined : PortfolioAdditionalClassificationFromJSON(json['additionalClassification']),
        'linkedPortfolioId': json['linkedPortfolioId'] == null ? undefined : json['linkedPortfolioId'],
        'linkType': json['linkType'] == null ? undefined : PortfolioLinkTypeFromJSON(json['linkType']),
        'linkStatus': json['linkStatus'] == null ? undefined : json['linkStatus'],
    };
}

export function PortfolioDetailsToJSON(json: any): PortfolioDetails {
    return PortfolioDetailsToJSONTyped(json, false);
}

export function PortfolioDetailsToJSONTyped(value?: PortfolioDetails | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'portfolioId': value['portfolioId'],
        'portfolioNumber': value['portfolioNumber'],
        'sequenceNumber': value['sequenceNumber'],
        'rubrik': value['rubrik'],
        'details': value['details'],
        'portfolioType': PortfolioTypeToJSON(value['portfolioType']),
        'portfolioStatus': PortfolioStatusToJSON(value['portfolioStatus']),
        'referenceCurrency': value['referenceCurrency'],
        'chargingCurrency': value['chargingCurrency'],
        'allocatedBo': value['allocatedBo'],
        'allocatedBoName': value['allocatedBoName'],
        'specialBoEnabled': value['specialBoEnabled'],
        'businessRelationshipId': value['businessRelationshipId'],
        'serviceAgreementId': value['serviceAgreementId'],
        'closedAt': value['closedAt'] == null ? value['closedAt'] : value['closedAt'].toISOString().substring(0,10),
        'activatedAt': value['activatedAt'] == null ? value['activatedAt'] : value['activatedAt'].toISOString().substring(0,10),
        'createdAt': value['createdAt'] == null ? value['createdAt'] : value['createdAt'].toISOString(),
        'createdBy': value['createdBy'],
        'modifiedAt': value['modifiedAt'] == null ? value['modifiedAt'] : value['modifiedAt'].toISOString(),
        'modifiedBy': value['modifiedBy'],
        'canBeEdited': value['canBeEdited'],
        'canEditDetails': value['canEditDetails'],
        'cashAccounts': value['cashAccounts'] == null ? undefined : ((value['cashAccounts'] as Array<any>).map(PortfolioCashAccountDetailsToJSON)),
        'servicingRole': PortfolioServicingRoleToJSON(value['servicingRole']),
        'externalAccountNumber': value['externalAccountNumber'],
        'externalAccountType': PortfolioExternalAccountTypeToJSON(value['externalAccountType']),
        'remarks': value['remarks'],
        'additionalClassification': PortfolioAdditionalClassificationToJSON(value['additionalClassification']),
        'linkedPortfolioId': value['linkedPortfolioId'],
        'linkType': PortfolioLinkTypeToJSON(value['linkType']),
        'linkStatus': value['linkStatus'],
    };
}

